@let eppDataValue = eppData();
@if (eppDataValue) {
  <div class="pigeon-epp-table-container">
    @let parametersetValue = parameterset();
    @if (parametersetValue) {
      <app-epp-table
        [parameterset]="parametersetValue"
        [resolution]="{ hourly: 1, days: 6 }"
        [stickyHeader]="false"
        [tableData]="eppDataValue"
        [userParameters]="userParameters()"
        [parameterDefinitions]="parameterDefinitions()"
        [highlightedHour]="hour()"></app-epp-table>
    }
  </div>
}
